import { useState, useEffect } from 'react';
import { Badge } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import ModalPayPending from '../Operaciones/documentation/ModalPayPending';
import { MailOpenIcon } from 'hugeicons-react';
import MailboxModal from './Components/MailboxModal';

const BannerTab = ({ background, badgeClassName, label, icon, count, onClick }) => (
	<div
		onClick={onClick}
		style={{
			position: 'relative',
			background,
			color: '#212121',
			borderTopLeftRadius: '8px',
			borderTopRightRadius: '8px',
			width: 'auto',
			padding: 16,
			height: 32,
			cursor: 'pointer',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			gap: 8,
			fontSize: 12,
			fontWeight: 500
		}}>
		{label}
		{icon}
		<Badge
			count={count}
			size="medium"
			className={badgeClassName}
			aria-hidden="true"
			title={null}
			style={{ position: 'absolute', right: -16, top: -25 }}
		/>
	</div>
);

const OperationBanners = ({
	showPendingPay,
	showMailbox,
	mailboxDocs = [],
	refreshData,
	refreshMailboxDocs,
	operationsData,
	userMortgageId
}) => {
	const { t } = useTranslation();
	const [isOpenModalPay, setIsOpenModalPay] = useState(false);
	const [isOpenModalMailbox, setIsOpenModalMailbox] = useState(false);
	const shouldAutoOpenMailbox = !!operationsData?.operationData?.process?.denialLetterModal;

	useEffect(() => {
		if (shouldAutoOpenMailbox) setIsOpenModalMailbox(true);
	}, [shouldAutoOpenMailbox]);

	if (!showPendingPay && !showMailbox) {
		if (!isOpenModalMailbox) return null;
		return (
			<MailboxModal
				open={isOpenModalMailbox}
				onCancel={() => setIsOpenModalMailbox(false)}
				docs={mailboxDocs}
				autoOpen={shouldAutoOpenMailbox}
				operationId={userMortgageId}
				refreshDocs={refreshMailboxDocs}
			/>
		);
	}

	return (
		<>
			<div
				style={{
					position: 'absolute',
					top: !isMobileOnly ? -32 : 0,
					right: 0,
					display: 'flex',
					alignItems: 'flex-end'
				}}>
				{showPendingPay && (
					<BannerTab
						background="#E1F7FF"
						badgeClassName="gb-badget"
						label={t('pending.pay')}
						count={1}
						icon={
							<CreditCardOutlined aria-hidden="true" focusable="false" style={{ fontSize: 14 }} />
						}
						onClick={() => setIsOpenModalPay(true)}
					/>
				)}
				{showMailbox && (
					<BannerTab
						background="#FF49F847"
						badgeClassName="gb-badget gb-badget-mailbox"
						label={t('notification.mailbox')}
						count={mailboxDocs.filter((doc) => doc?.tags?.includes('unread')).length}
						icon={<MailOpenIcon size={16} aria-hidden="true" focusable="false" />}
						onClick={() => setIsOpenModalMailbox(true)}
					/>
				)}
			</div>

			<ModalPayPending
				getDataOperation={refreshData}
				setModalPay={setIsOpenModalPay}
				modalPay={isOpenModalPay}
				mortgage={operationsData}
				operationId={userMortgageId}
			/>

			<MailboxModal
				open={isOpenModalMailbox}
				onCancel={() => setIsOpenModalMailbox(false)}
				docs={mailboxDocs}
				autoOpen={shouldAutoOpenMailbox}
				operationId={userMortgageId}
				refreshDocs={refreshMailboxDocs}
			/>
		</>
	);
};

export default OperationBanners;
